import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="bg-brand-dark text-white py-16 md:py-24 px-4 overflow-hidden" data-id="element-82">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-83">
        {/* Left Column: Copy & CTAs */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl" data-id="element-84">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-85">
            Lancer Service · St. Paul, MN
          </span>
          <h1 className="font-heading uppercase tracking-wide text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6" data-id="element-86">
            Stop replacing parts that don't fix the problem.
          </h1>
          <div className="text-lg md:text-xl text-gray-300 mb-8 space-y-4" data-id="element-87">
            <p className="font-bold text-white" data-id="element-88">
              Nothing is more frustrating than fixing the same problem twice.
            </p>
            <p data-id="element-89">
              Many recurring vehicle problems happen because the original shop
              didn’t have the tools needed to confirm the real cause. When the
              guess is wrong, the problem comes back and the repair starts over
              — turning what looked like the cheaper option into multiple
              repairs and unnecessary parts.
            </p>
            <p data-id="element-90">
              At Lancer Service, our ASE-certified technicians use advanced
              diagnostic equipment and manufacturer service data to identify the
              real failure before recommending any repair.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-91">
            <a href="https://www.lancerservice.com/" target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center px-8 py-4 bg-brand-accent hover:bg-brand-accentHover text-white font-bold rounded-md transition-colors shadow-lg shadow-brand-accent/20" data-id="element-92">
              Schedule Free Inspection
            </a>
            <a href="#diagnostic-process" className="inline-flex justify-center items-center px-8 py-4 bg-transparent border-2 border-gray-600 hover:border-gray-400 text-white font-bold rounded-md transition-colors" data-id="element-93">
              See How We Diagnose Problems
            </a>
          </div>

          <div className="text-sm text-gray-400 font-medium" data-id="element-94">
            <p data-id="element-95">Free estimates · Photos & video included</p>
          </div>
        </motion.div>

        {/* Right Column: Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative lg:pl-12" data-id="element-96">
          <img src="https://cdn.magicpatterns.com/uploads/ttPJFZ4aUyNtMWivQkpBwk/7.5.24Used-0316_Profile_RW_003.jpg" alt="ASE-certified master technician using advanced diagnostic equipment" className="w-full rounded-2xl shadow-2xl shadow-black/40 object-cover aspect-[4/3]" data-id="element-97" />
        </motion.div>
      </div>
    </section>;
}